import React, { useState , useContext } from "react";
import app from "../base";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../Auth";
import NavLogo from "../Asset/NavLogo.png"
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from "../images/logo text.png" 
 import Logo2 from "../images/logo pic.png" 
 import Risk from "../images/risk.png"
import Search from "../images/search.png"
import Start from "../images/start.png"

const SuggestionHealthy = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [base64, setBase64] = useState(null);

  
  const handleChange = (e) => {
    const file = e.target.files[0];
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validImageTypes.includes(file.type)) {
      console.log("Invalid file type. Please select an image file.");
      return;
    }
    setFile(file);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
        const base64 = fileReader.result;
        setBase64(base64);
        console.log(base64)
    };
};

const handleUpload = async () => {
  if (!file) {
      console.log("No file selected. Please select a file before uploading.");
      return;
  }
  const db = app.firestore();
  const fileRef = db.collection("EIPCA").doc();
  try {
      await fileRef.set({ 
        userid: currentUser.uid,
        file: base64,
        status: "NotPredict",
        Result: "null",
        Time: "null",
        History: "NotHistoried"
      });
      alert("File uploaded successfully!");
      history.push("/history");
      window.location.reload(true)
  } catch (error) {
      console.log(error);
  }
};

  const Backhome = () => {
    history.push("/");
    window.location.reload(true)
  }

  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };


// Change file to Field for firestore

  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/en/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              Service <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center>
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              News from EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/about">
              About us
            </Nav.Link>
          </li>
        </center>
        
        
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >Sign out</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/en/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/SuggestionHealthy">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/SuggestionHealthy">
              EN
            </Nav.Link>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>

 

    <center>
     {/* Header */}
  <header className="ex-header bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1">
        <h1 >Electrocardiogram Check-ups</h1>
          <h2 className="mt-4"> {currentUser.displayName} </h2>
          <p class="fs-2" style={{marginTop: "4%"}}>Range of risk in EIPCA ECG-Check-ups</p>
          
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
  </center>
  {/* end of ex-header */}
  {/* end of header */}
  {/* Basic */}
 
  {/* Basic */}

 
 
    
  <div className="ex-basic-1 pt-4">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1">
        <h2 className="mb-3" style={{color: "#7ED957"}}>No Risk</h2>
          <div className="header8" /> <div className="header9" />
          <br />
          <br />
          <p className="mb-4">
          You have no significant risk of heart and cardiovascular diseases. Therefore, it is important for you to take care of yourself regularly. To raise awareness about this condition, we would like to provide you with information. The heart and blood vessels work together continuously to deliver nutrient-rich blood and, most importantly, oxygen to various parts of the body. The heart itself also requires nutrients and oxygen for nourishment.

After delivering nutrients and oxygen, the system removes waste products and carbon dioxide from that area and returns them to the lungs for elimination through respiration. It then takes in fresh oxygen and circulates it back into the bloodstream to be pumped by the heart to various parts of the body.

These processes occur constantly, whether we are awake or asleep, without any rest. This system in our body is called the cardiovascular system, which works in harmony with the heart and blood circulation.
          </p>
          <p className="mb-4">
          Abnormalities that affect this system include high blood pressure, which can weaken the blood vessel walls and lead to the possibility of blood vessel rupture. If a rupture occurs in the brain, it can result in the compression of brain functions, leading to a stroke, loss of consciousness, or even death. Another potential abnormality is the buildup of fatty deposits on the walls of blood vessels, which can cause blockages. If a blockage occurs in the coronary arteries that supply the heart, it can lead to a condition called coronary heart disease. If a blockage occurs in the arteries that supply the brain, it can result in a stroke.
          </p>
          <br/>
          <p style={{marginBottom: '4px'}}>
          <strong>Source : </strong>Bankok Heart Hostital <a style={{textDecoration: "none"}} href="https://www.bangkokhearthospital.com/content/regular-exercise-is-important-when-you-have-heart-disease"> -ข่าวสารสุขภาพ-โรงพยาบาลหัวใจกรุงเทพ-</a>
          </p>
          <br />
          
          <h2 className="mb-3" style={{color: "darkgreen"}}>Low Risk</h2>
          <div className="header8" /> <div className="header9" />
          <br />
          <br />
          <p className="mb-4">
          
            With a low risk, it is recommended that you start exercising to improve the pumping efficiency of your heart and enhance blood circulation throughout your body. Exercise is important for individuals with heart disease as it helps the heart become stronger, allowing it to pump blood to different parts of the body more effectively. Regular exercise can also increase blood flow to the heart, stimulate the function of the cells in the blood vessel walls, and reduce the accumulation of plaque in the arteries. It can help alleviate symptoms of coronary heart disease and improve your ability to engage in daily activities, leading to a healthier and stronger cardiovascular system.       </p>
           <p className="mb-4">

          
For individuals experiencing initial symptoms, it is important to pay attention to self-assessment during exercise. This includes monitoring heart rate, blood pressure, oxygen levels (if available), and the level of exertion in your body. It is crucial to observe any signs or symptoms that may indicate abnormalities, such as chest pain, dizziness, lightheadedness, or darkening vision. These could be warning signs that you are exerting yourself too much, and it is advisable to stop exercising immediately and consult a medical professional.
          </p>

          <p style={{marginBottom: '4px'}}>
            <strong>Source : </strong>Bankok Heart Hospital <a style={{textDecoration: "none"}} href="https://www.bangkokhearthospital.com/content/regular-exercise-is-important-when-you-have-heart-disease"> -ข่าวสารสุขภาพ-โรงพยาบาลหัวใจกรุงเทพ-</a>
          </p>
          <br />
          <center>
          <img style={{marginTop: '4px'}}
            src="https://img.freepik.com/premium-vector/cute-funny-heart-organ-make-gym-with-dumbbells-vector-flat-line-cartoon-kawaii-character-illustration-icon-isolated-white-background-heart-organ-workout-cartoon-character-concept_92289-2919.jpg?w=826"
            width= "30%"
          />
          </center>
          <br />
          <h2 className="mb-3" style={{color: "darkorange" }}>Moderate Risk</h2>
          <div className="header8" /> <div className="header9" />
          <br/>
          <br/>
          <p className="mb-4">
          With a moderate risk, it is important for you to engage in regular exercise and reduce smoking habits. Smoking is known to increase the risk of lung cancer, chronic bronchitis, and emphysema, as well as significantly raise the chances of developing cardiovascular diseases. Smokers are more than twice as likely to have a heart attack and have a four-fold increased risk of sudden cardiac death compared to non-smokers.

Controlling your diet by reducing foods high in saturated fats and cholesterol is also crucial. Having high levels of cholesterol in the blood increases the likelihood of developing and exacerbating heart disease. To maintain normal cholesterol levels, it is necessary to plan your diet by choosing foods low in fats and cholesterol.
          </p>
           <p className="mb-4">
         
If there is a family history of heart disease, such as in the case of a father, mother, grandparents, or siblings, you have a higher chance of developing heart disease. Your lifestyle habits and genetic factors can play a role in this. Additionally, individuals aged 55 and above are more susceptible to coronary artery disease, as the risk of developing plaque in the blood vessels increases with age, regardless of gender.

Regarding gender, research shows that coronary artery disease is more prevalent in males than females. This may be attributed to certain female sex hormones that help regulate the levels of fats in the body. After menopause, women have an increased risk of heart disease.

It's important to be aware of these risk factors and take appropriate measures to maintain heart health. This includes adopting a healthy lifestyle, managing other risk factors like blood pressure and cholesterol levels, and seeking regular medical check-ups.
          </p>
          <p className="mb-4">
            <strong>
Therefore, for a moderate level of risk, it is advisable for you to start consulting a physician or consider undergoing a detailed electrocardiogram (ECG) examination at a hospital to receive a thorough diagnosis from a specialized doctor. The ECG test can help analyze and assess the condition of your heart more accurately, aiding in making informed decisions regarding treatment and long-term heart health management.</strong>
          </p>

          <p style={{marginBottom: '4px'}}>
            <strong>Source : </strong>Bumrungrad International Hospital<a style={{textDecoration: "none"}} href="https://www.bumrungrad.com/th/conditions/heart-diseases?gclid=Cj0KCQjwtsCgBhDEARIsAE7RYh188O4koyv3MUfrhbTkgHa_BwesRYwmt01LthiDjOupHTz4Gu9u-28aAp7UEALw_wcB"> -โรงพยาบาลบำรุงราษฎร์ในกรุงเทพ-</a>
          </p>
          <center>
          <img style={{marginTop: '4px'}}
            src="https://i.pinimg.com/564x/c7/c9/34/c7c934464b3b5fa6a5e7d42cba919d94.jpg"
            width= "30%"
          />
          </center>
          <br />
          <h2 className="mb-3 font" style={{color: "red"}}>High Risk</h2>
          <div className="header8" /> <div className="header9" />
          <br/>
          <br/>
          <p className="mb-4">
          With a high level of risk, you have the highest chance of developing Brugada Syndrome. Therefore, it is crucial for you to seek medical attention as soon as possible to undergo a detailed cardiac examination and receive a diagnosis and treatment plan from a specialized physician.

Additionally, you should regularly monitor yourself and be vigilant for any severe symptoms. If you experience severe symptoms or have never experienced them before, it is important to seek immediate medical attention or contact the emergency hotline at 1669.</p>
           <p className="mb-4">
            
I apologize for any confusion. As an AI language model, I don't have the capability to search for hospitals or provide real-time information. However, you can use online search tools or contact local healthcare authorities in your province to find hospitals near you or hospitals certified as heart centers. They will be able to provide you with the most accurate and up-to-date information.
          </p>
          <p style={{marginBottom: '4px'}}>
            <strong>Source : </strong>Bankok Heart Hospital <a style={{textDecoration: "none"}} href="https://www.bangkokhearthospital.com/content/regular-exercise-is-important-when-you-have-heart-disease"> -ข่าวสารสุขภาพ-โรงพยาบาลหัวใจกรุงเทพ-</a>
          </p>
 
        
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of ex-basic-1 */}
  {/* end of basic */}
  <div className="ex-basic-1  pb-4">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1">
          <div className="text-box ">
            <p>
              <strong>"Dying from heart disease can occur in both cases, where individuals are aware of their heart condition and in cases where individuals are unaware because they have no symptoms. Therefore, it is important to be vigilant and closely monitor any abnormalities in your own body. Do not neglect any signs of potential health issues.

For individuals with mild or no symptoms, the most important thing is to control and manage the risk factors. This includes managing diabetes, blood pressure, and cholesterol levels, maintaining a healthy weight, and engaging in appropriate physical activity. By doing so, you can significantly reduce the risk of developing severe heart problems in the future."
              </strong><br/><br/>
              Dr. Watchanawat Boonsom, Director of the 24-Hour Heart Center at Vichai Vej Hospital, Nongkhaem.
            </p>
          </div>{" "}
          {/* end of text-box */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of ex-basic-1 */}
  {/* end of basic */}

{/* footer */}
  <div className="footer bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="footer-col first">
            <h6 className="font-face-gm">About EIPCA</h6>
            <p className="p-small font-face-gl">
            EIPCA stands for Electrocardiogram Interpretation Pattern for Symptom Predictions of Arrhythmia, a program aimed at assisting in the screening of sudden cardiac arrest (sudden death) caused by irregular heart rhythms through the analysis of electrocardiogram waveforms using artificial intelligence.
            </p>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col second font-face-gm">
            <h6 className="font-face-gm">Contact Us</h6>
            <ul className="list-unstyled li-space-lg p-small font-face-gl">
              <p>
                <i className="fa fa-map-marker-alt mr-2" />
                EIPCA Team 
              </p>
              <p>
                <i className="fa fa-phone-alt mr-2" />
                093-2789556 , 081-2895915 , 
              </p>
              <p>
                <i className="fa fa-phone-alt mr-2" />
                065-3595514
              </p>
              <p>
                <i className="fa fa-envelope mr-2" />
                EIPCAhackathon@gmail.com
              </p>
            </ul>
          </div>{" "}
          {/* end of footer-col */}
          <div className="footer-col third font-face-gm">
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-facebook-f fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-twitter fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-pinterest-p fa-stack-1x" />
              </a>
            </span>
            <span className="fa-stack">
              <a href="#your-link">
                <i className="fas fa-circle fa-stack-2x" />
                <i className="fab fa-instagram fa-stack-1x" />
              </a>
            </span>
            <p className="p-small">
              We would love to hear from you{" "}
              <a href="">
                <strong>EIPCAhackathon@gmail.com</strong>
              </a>
            </p>
          </div>{" "}
          {/* end of footer-col */}
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </div>{" "}
  {/* end of footer */}
 

      
    </>
  );
};

export default withRouter(SuggestionHealthy);